import { buttonVariants, cn } from "@heroui/react";
import { Link } from "react-router";
import type { ButtonProps } from "./Button";
import { resolveButtonProps } from "./resolveButtonProps";

export type LinkButtonProps = ButtonProps;

/**
 * Button-styled navigation link. v3's HeroButton is a React Aria button and
 * cannot render as an anchor, so link buttons use v3 `buttonVariants` on a
 * real `<a>` or React Router `<Link>`.
 */
export default function LinkButton(props: LinkButtonProps) {
  const {
    size = "md",
    href,
    to,
    "data-testid": dataTestId,
    "aria-label": ariaLabel,
    id,
    isIconOnly,
    fullWidth,
  } = props;

  const {
    variant: heroVariant,
    style,
    className: buttonClassName,
    children,
  } = resolveButtonProps(props);

  const linkClassName = cn(
    buttonVariants({ variant: heroVariant, size, isIconOnly, fullWidth }),
    buttonClassName,
  );

  if (href != null) {
    return (
      <a
        href={href}
        data-testid={dataTestId}
        aria-label={ariaLabel}
        id={id}
        className={linkClassName}
        style={style}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      to={to ?? ""}
      data-testid={dataTestId}
      aria-label={ariaLabel}
      id={id}
      className={linkClassName}
      style={style}
    >
      {children}
    </Link>
  );
}
